var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"height":"100%"},attrs:{"src":_vm.faceSrc},on:{"error":function($event){return _vm.onError($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }